import React, { forwardRef, useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { editorS3FileManagerServices } from "../../../APIServices/Editor/editorS3FileManagerServices";
import { useParams } from "react-router";
import Swal from "sweetalert2";

const MoveFolder = forwardRef(({ Show, Hide, Title, sourceKey, folderData, setFileFolderUpdater, handleAddNewTab }, ref) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [selectedPaths, setSelectedPaths] = useState([]);
  const [destinationKey, setDestinationKey] = useState("");
  const [loader, setLoader] = useState(false);
  const [fileManager, setFileManager] = useState([]);
  const { studyId } = useParams()

  const getS3EditorFolders = async () => {
    setLoader(true);
    let data = await editorS3FileManagerServices.getS3EditorFolders(studyId, "root", "", "", "folder");
    setFileManager(data?.data || []);
    setLoader(false);
  };

  const moveS3EditorFolder = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Move!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Move it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true)
        let userData = { studyId };
        userData.sourceKey = sourceKey
        userData.destinationKey = `${destinationKey}`
        let data = await editorS3FileManagerServices.moveS3EditorFolder(
          userData
        );
        setButtonLoader(false)
        if (data?.statusCode === 200) {
          setFileFolderUpdater(Math.floor(1000000000 + Math.random() * 9000000000));
          if (folderData) {
            handleAddNewTab(`File Management`,
              "fa-solid fa-desktop",
              `fileManagement`,
              { ...folderData, fullPath: `${destinationKey}${(folderData?.fullPath || "").split("/").filter(Boolean).pop() || ""}/` }
            )
          }
          setDestinationKey("")
          Hide()
        }
      }
    });
  };

  const getChildren = (path, items = fileManager) => {
    if (!path) return items;
    for (const item of items) {
      if (item.fullPath === path) return item.children || [];
      if (item.children?.length) {
        const found = getChildren(path, item.children);
        if (found.length) return found;
      }
    }
    return [];
  };

  const getFolderName = (path, items = fileManager) => {
    for (const item of items) {
      if (item.fullPath === path) return item.name;
      if (item.children?.length) {
        const found = getFolderName(path, item.children);
        if (found) return found;
      }
    }
    return null;
  };

  const handleChange = (level, value) => {
    const newSelectedPaths = [...selectedPaths];
    newSelectedPaths[level] = value;
    newSelectedPaths.splice(level + 1);
    setSelectedPaths(newSelectedPaths);
    setDestinationKey(value || newSelectedPaths[level - 1] || "");
  };

  const renderDropdowns = () => {
    const dropdowns = [];
    let currentItems = fileManager;
    for (let i = 0; i <= selectedPaths.length; i++) {
      if (!currentItems || currentItems.length === 0) break;
      const parentPath = i === 0 ? null : selectedPaths[i - 1];
      const parentName = parentPath ? getFolderName(parentPath) : null;
      dropdowns.push(
        <Form.Group className="mb-1" key={i}>
          <Form.Label className="mb-1 fw-bold">
            {parentName
              ? `Select Folder inside "${parentName}"`
              : "Select Root Folder"}
            {i === 0 &&
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            }
          </Form.Label>
          <Form.Select
            disabled={loader}
            value={selectedPaths[i] || ""}
            onChange={(e) => handleChange(i, e.target.value)}
          >
            <option value="">Select Folder Path</option>
            {i === 0 &&
              <option value="/">Main Root</option>
            }
            {currentItems.map((folder) => (
              <option key={folder.fullPath} value={folder.fullPath}>
                {folder.name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      );
      const currentPath = selectedPaths[i];
      if (!currentPath) break;
      currentItems = getChildren(currentPath);
    }
    return dropdowns;
  };

  useEffect(() => {
    getS3EditorFolders()
  }, []);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <div ref={ref} className="d-flex flex-column h-100">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>{Title}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            {renderDropdowns()}
          </Offcanvas.Body>
          <div className="text-end p-2 border-top">
            <button
              onClick={moveS3EditorFolder}
              disabled={buttonLoader || !destinationKey}
              title={Title}
              className="updateProfile"
            >
              {buttonLoader ? (
                <div className="hstack gap-2">
                  <Spinner size="sm" /> Moving...
                </div>
              ) : (
                "Move Now"
              )}
            </button>
          </div>
        </div>
      </Offcanvas>
    </>
  );
});

export default MoveFolder;
